import { render, staticRenderFns } from "./RHL.vue?vue&type=template&id=671e857b"
import script from "./RHL.vue?vue&type=script&lang=js"
export * from "./RHL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports